"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@sentry/utils");
var DataScrubberIntegration = (function () {
    function DataScrubberIntegration(options) {
        this.name = DataScrubberIntegration.name;
        this._options = __assign({ sanitizeKeys: [] }, options);
        this._sanitizeMask = "******";
    }
    DataScrubberIntegration.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event, _hint) {
            var self = getCurrentHub().getIntegration(DataScrubberIntegration);
            if (self) {
                return self.process(event);
            }
            return event;
        });
    };
    DataScrubberIntegration.prototype.process = function (event) {
        if (this._options.sanitizeKeys.length === 0) {
            return event;
        }
        return this._sanitize(event);
    };
    DataScrubberIntegration.prototype._sanitize = function (input, memo) {
        var _this = this;
        if (memo === void 0) { memo = utils_1.memoBuilder(); }
        var inputIsArray = Array.isArray(input);
        var inputIsPlainObject = utils_1.isPlainObject(input);
        if (!inputIsArray && !inputIsPlainObject) {
            return input;
        }
        var _a = __read(memo, 2), memoize = _a[0], unmemoize = _a[1];
        if (memoize(input)) {
            return input;
        }
        var sanitizedValue;
        if (inputIsArray && Array.isArray(input)) {
            sanitizedValue = input.map(function (value) { return _this._sanitize(value, memo); });
        }
        else if (inputIsPlainObject) {
            var inputVal_1 = input;
            sanitizedValue = Object.keys(inputVal_1).reduce(function (acc, key) {
                acc[key] = _this._sanitizeRegExp().test(key)
                    ? _this._sanitizeMask
                    : _this._sanitize(inputVal_1[key], memo);
                return acc;
            }, {});
        }
        unmemoize(input);
        return sanitizedValue;
    };
    DataScrubberIntegration.prototype._sanitizeRegExp = function () {
        if (this._lazySanitizeRegExp) {
            return this._lazySanitizeRegExp;
        }
        var sources = this._options.sanitizeKeys.reduce(function (acc, key) {
            if (typeof key === "string") {
                acc.push(key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
            }
            else if (utils_1.isRegExp(key)) {
                acc.push(key.source);
            }
            return acc;
        }, []);
        return (this._lazySanitizeRegExp = RegExp(sources.join("|"), "i"));
    };
    DataScrubberIntegration.id = "DataScrubberIntegration";
    return DataScrubberIntegration;
}());
exports.default = DataScrubberIntegration;
//# sourceMappingURL=data_scrubber.js.map